var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Max documents")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: -1,
                      decimals: 0,
                      label: "Max aantal documenten per maand",
                    },
                    model: {
                      value: _vm.maxDocuments,
                      callback: function ($$v) {
                        _vm.maxDocuments = $$v
                      },
                      expression: "maxDocuments",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" Bevestigen ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }